import { c as _c } from "react/compiler-runtime";
import { useChartContext } from '#components/chart/context/useChartContext';
import { FC } from 'react';
export const VerticalCursor: FC<{
  payload?: Array<{
    payload: {
      show: boolean;
    };
  }>;
  points?: Array<{
    x: number;
    y: number;
  }>;
}> = props => {
  const $ = _c(5);
  const {
    options: t0
  } = useChartContext();
  const {
    colors
  } = t0;
  const {
    payload,
    points
  } = props;
  if (!points?.length || shouldHideCursor(payload)) {
    return null;
  }
  let t1;
  if ($[0] !== colors.CURSOR_LINE || $[1] !== points[0].x || $[2] !== points[1].x || $[3] !== points[1].y) {
    t1 = <svg><line x1={points[0].x} y1={0} x2={points[1].x} y2={points[1].y} stroke={colors.CURSOR_LINE} /></svg>;
    $[0] = colors.CURSOR_LINE;
    $[1] = points[0].x;
    $[2] = points[1].x;
    $[3] = points[1].y;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};

/**
 * Avoid showing the cursor for padding points at the beginning and end of the data.
 **/
const shouldHideCursor = (payload?: Array<{
  payload: {
    show: boolean;
  };
}>): boolean => {
  return payload?.every(p => p.payload?.show === false) ?? true;
};